export type Locale = {
  code: string
  iso: string
  dir: 'ltr' | 'rtl' // Assuming only 'ltr' and 'rtl' are valid directions.
  countryCode: string
  lang: string
  countryName: string
  currency: string
  dato: false | string
  shopifyMarketHandle: string
}

/**
 * The hand-written locales search engines are told about. Kept hand-written
 * because config/sitemaps.ts is imported at the top of nuxt.config.ts, before
 * build:before fetches the Shopify country list (ADR-0005).
 */
export type ContentLocale = Locale

/**
 * One per country we sell to, derived in ./storefrontLocales. Resolves to a
 * Market for pricing and to the Content Locale it points search engines at.
 */
export type StorefrontLocale = Locale & {
  contentLocale: ContentLocale['code']
}

export const locales: Locale[] = [
  {
    code: 'en-gb',
    iso: 'en-GB',
    dir: 'ltr',
    countryCode: 'gb',
    lang: 'en',
    countryName: 'United Kingdom',
    currency: 'GBP',
    dato: 'en_GB',
    shopifyMarketHandle: 'gb',
  },
  {
    code: 'en-au',
    iso: 'en-AU',
    dir: 'ltr',
    countryCode: 'au',
    lang: 'en',
    countryName: 'Australia',
    currency: 'AUD',
    dato: 'en_NZ',
    shopifyMarketHandle: 'australia',
  },
  {
    code: 'en-ca',
    iso: 'en-CA',
    dir: 'ltr',
    countryCode: 'ca',
    lang: 'en',
    countryName: 'Canada',
    currency: 'CAD',
    dato: false,
    shopifyMarketHandle: 'canada',
  },
  {
    code: 'en-ch',
    iso: 'en-CH',
    dir: 'ltr',
    countryCode: 'ch',
    lang: 'en',
    countryName: 'Switzerland',
    currency: 'CHF',
    dato: false,
    shopifyMarketHandle: 'switzerland',
  },
  {
    code: 'en-eu',
    iso: 'en-EU',
    dir: 'ltr',
    countryCode: 'eu',
    lang: 'en',
    countryName: 'Europe',
    currency: 'EUR',
    dato: false,
    shopifyMarketHandle: 'eu',
  },
  {
    code: 'en-nz',
    iso: 'en-NZ',
    dir: 'ltr',
    countryCode: 'nz',
    lang: 'en',
    countryName: 'New Zealand',
    currency: 'NZD',
    dato: 'en_NZ',
    shopifyMarketHandle: 'new-zealand',
  },
  {
    code: 'en-us',
    iso: 'en-US',
    dir: 'ltr',
    countryCode: 'us',
    lang: 'en',
    countryName: 'United States',
    currency: 'USD',
    dato: 'en_US',
    shopifyMarketHandle: 'usa',
  },
]
